import { render } from "./TerminusOrigen.vue?vue&type=template&id=6641fd36&scoped=true&ts=true"
import script from "./TerminusOrigen.vue?vue&type=script&lang=ts"
export * from "./TerminusOrigen.vue?vue&type=script&lang=ts"

import "./TerminusOrigen.vue?vue&type=style&index=0&id=6641fd36&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6641fd36"]])

export default __exports__